import { render, staticRenderFns } from "./CdEstoque.vue?vue&type=template&id=179f6140"
import script from "./CdEstoque.vue?vue&type=script&lang=js"
export * from "./CdEstoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports